<template>
  <div class="person-center-type">
    <div
      v-for="tab in typeTabs"
      :key="tab.type"
      :class="currentTab === tab.type ? 'person-center-type-selected' : ''"
      @click="onTabClick(tab)"
    >
      {{ tab.name }}
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "currentTab",
    event: "onChange"
  },
  props: {
    currentTab: {
      type: String,
      default: "outpatient"
    },
    typeTabs: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onTabClick(tab) {
      this.$emit("onChange", tab.type);
      this.$emit("changeType", tab.type);
    }
  }
};
</script>

<style lang="less">
.person-center-type {
  display: flex;
  align-items: center;
  justify-content: space-around;
  float: right;
  width: 6.5rem;
  height: 2rem;
  margin: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0.5rem;

  > div {
    width: 3rem;
    color: white;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1.63rem;
    text-align: center;
  }

  &-selected {
    color: #108eee !important;
    background: white;
    border-radius: 0.5rem;
  }
}
</style>
